import React from 'react'
import { BTitle } from '@prague-digi/ui-components'

interface Props {}

export const NotImplementedPage: React.FunctionComponent<Props> = () => (
  <div>
    <BTitle type="h3">Další stránka ještě nebyla naimplementována</BTitle>
  </div>
)

export default NotImplementedPage
